document.addEventListener("DOMContentLoaded", () => {
    const logoContainers = document.querySelectorAll(".clickable-logo-container");
    const popupOverlay = document.getElementById("popup-overlay");
    const popupImage = document.getElementById("popup-image");
    const popupClose = document.getElementById("popup-close");

    logoContainers.forEach(container => {
        container.addEventListener("click", () => {
            const imageUrl = container.getAttribute("data-image");
            if (imageUrl) {
                popupImage.src = imageUrl;
                popupOverlay.style.display = "flex";
            }
        });
    });

    popupClose.addEventListener("click", () => {
        popupOverlay.style.display = "none";
        popupImage.src = "";
    });

    popupOverlay.addEventListener("click", (e) => {
        if (e.target === popupOverlay) {
            popupOverlay.style.display = "none";
            popupImage.src = "";
        }
    });
});